import { fetchUserInfo } from "@/apis/auth"
import { getUserInfo } from "./common"
import { clearAuth } from "./token"
import { getOrigin } from "./host"
// import { formatDate } from "./datetime"

// 获取 client 对象
export const getClient = () => window.top.myoa_client || window.myoa_client || window.top.client || window.client || {}
export const isClient = window.top.client && !window.top.client.isWeb
const userInfo = null

async function isTokenExpire() {
  const info = await getTokenUserInfo()
  // console.log('exp', formatDate(new Date(info.exp * 1000), 'yyyy-MM-dd hh:mm'))
  // console.log('iat', formatDate(new Date(info.iat * 1000), 'yyyy-MM-dd hh:mm'))
  return new Date().getTime() >= info.exp * 1000
}

async function getTokenUserInfo() {
  const token = await getLocalToken()
  return getUserInfo(token)
}

const getLocalToken = async () => localStorage.getItem('accessToken')

// 获取用户信息
export const loadUserInfo = () => {
  if (!userInfo) {
    return isClient ? getClient().loadUserInfo() : fetchUserInfo().then(res => res.data)
  }

  return userInfo
}

// 关闭浏览器窗口
export const closeBrowser = () => {
  if (!window.webkit) return;
  let message = "browser_close";
  let messageObj = {
    type: message,
  };
  let stringifiedMessageObj = JSON.stringify(messageObj);
  window.webkit.messageHandlers.cordova_iab.postMessage(
    stringifiedMessageObj
  );
}

export const globalClient = {
  isWeb: true,
  // token是否过期
  isTokenExpire,
  // 返回client类型
  getClientType: () => 'web',
  // 获取token
  getUserAccessToken: getLocalToken,
  getAccessToken: getLocalToken,
  // 获取token解析的用户信息
  getUserInfo: getTokenUserInfo,
  // 获取用户接口返回的信息
  loadUserInfo() {
    return fetchUserInfo().then(res => res.data)
  },
  // 退出登录
  logout: clearAuth,
  // 返回当前host
  async getHomeHost() {
    return getOrigin()
  }
}